import React from 'react';

const PasswordStrengthIndicator = ({ password }) => {
  const calculateStrength = (pwd) => {
    let score = 0;
    
    if (!pwd) return { score: 0, label: '', color: 'gray' };
    
    // Longitud
    if (pwd.length >= 8) score += 1;
    if (pwd.length >= 12) score += 1;
    if (pwd.length >= 16) score += 1;
    
    // Complejidad
    if (/[a-z]/.test(pwd)) score += 1;
    if (/[A-Z]/.test(pwd)) score += 1;
    if (/[0-9]/.test(pwd)) score += 1;
    if (/[!@#$%^&*()_+\-=\[\]{}|;:,.<>?]/.test(pwd)) score += 1;
    
    // Determinar nivel
    if (score <= 2) return { score: 1, label: 'Muy débil', color: 'red' };
    if (score <= 3) return { score: 2, label: 'Débil', color: 'orange' };
    if (score <= 5) return { score: 3, label: 'Moderada', color: 'yellow' };
    if (score <= 6) return { score: 4, label: 'Fuerte', color: 'lime' };
    return { score: 5, label: 'Muy fuerte', color: 'green' };
  };

  const strength = calculateStrength(password);

  if (!password) return null;

  const getColorClass = (color, index) => {
    const colors = {
      red: index < strength.score ? 'bg-red-500' : 'bg-slate-200 dark:bg-slate-700',
      orange: index < strength.score ? 'bg-orange-500' : 'bg-slate-200 dark:bg-slate-700',
      yellow: index < strength.score ? 'bg-yellow-500' : 'bg-slate-200 dark:bg-slate-700',
      lime: index < strength.score ? 'bg-lime-500' : 'bg-slate-200 dark:bg-slate-700',
      green: index < strength.score ? 'bg-green-500' : 'bg-slate-200 dark:bg-slate-700',
      gray: 'bg-slate-200 dark:bg-slate-700'
    };
    return colors[color] || colors.gray;
  };

  const getTextColorClass = (color) => {
    const colors = {
      red: 'text-red-600 dark:text-red-400',
      orange: 'text-orange-600 dark:text-orange-400',
      yellow: 'text-yellow-600 dark:text-yellow-400',
      lime: 'text-lime-600 dark:text-lime-400',
      green: 'text-green-600 dark:text-green-400',
      gray: 'text-slate-500 dark:text-slate-400'
    };
    return colors[color] || colors.gray;
  };

  return (
    <div className="mt-2">
      {/* Barras de fortaleza */}
      <div className="flex gap-1 mb-1">
        {[0, 1, 2, 3, 4].map((index) => (
          <div
            key={index}
            className={`h-1.5 flex-1 rounded-full transition-all duration-300 ${getColorClass(strength.color, index)}`}
          />
        ))}
      </div>
      
      {/* Etiqueta */}
      <div className="flex items-center justify-between">
        <span className={`text-xs font-medium ${getTextColorClass(strength.color)}`}>
          {strength.label}
        </span>
        <span className="text-xs text-slate-500 dark:text-slate-400">
          {password.length} caracteres
        </span>
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;
